/* eslint-disable react/destructuring-assignment */
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Loading from 'components/Loading';
import { FirebaseAuth } from 'FirebaseInit';

import PrivateRoute from 'components/Auth/PrivateRoute';

const Home = (lazy(() => import('./components/Home')));
const Compare = lazy(() => import('./containers/Compare'));
const Capture = lazy(() => import('./containers/Capture'));
const Timestamp = lazy(() => import('./containers/Timestamp'));
const DataGrid = lazy(() => import('./containers/DataGrid'));
const ImageComparison = lazy(() => import('./containers/ImageComparison'));
const Configuration = lazy(() => import('./containers/Configuration'));
const Login = lazy(() => import('./containers/Login'));
const NotFound = lazy(() => import('./components/NotFound'));


interface AppState {
user: any;
authenticated: boolean;
loading: boolean;
}

export default class App extends React.Component<{}, AppState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: true,
      authenticated: false,
      user: undefined,
    };
  }

  componentDidMount() {
  // TODO: Authorization, if they have the same email, or pricespider email,
  // allow access, otherwise, do NOT.
  // Parse through URL Params, then determine the logic afterwards.
    FirebaseAuth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authenticated: true,
          user,
          loading: false,
        });
      } else {
        this.setState({
          user: undefined,
          authenticated: false,
          loading: false,
        });
      }
    });
  }

  render() {
    if (this.state.loading) { return <Loading center />; }

    return (
      <Router>
        <main>
          <Suspense fallback={<Loading center />}>
            <Switch>
              <Route path="/" exact component={Home} />
              <PrivateRoute path="/compare" exact CustomComponent={Compare} user={this.state.authenticated} />
              <PrivateRoute path="/capture/:id" exact CustomComponent={Capture} user={this.state.authenticated} />
              <PrivateRoute path="/list-capture/:id" exact CustomComponent={Capture} user={this.state.authenticated} />
              <PrivateRoute path="/Configuration" exact CustomComponent={Configuration} user={this.state.authenticated} />
              <PrivateRoute path="/manufacturer/:manufacturer/country/:country/sku/:sku/images" exact CustomComponent={ImageComparison} user={this.state.authenticated} />
              <PrivateRoute path="/capture/:id/timestamp" exact CustomComponent={Timestamp} user={this.state.authenticated} />
              <PrivateRoute path="/data-grid" exact CustomComponent={DataGrid} user={this.state.authenticated} />
              <Route path="/login" exact component={Login} />
              <Route path="/404" exact component={NotFound} />
            </Switch>
          </Suspense>
          <img
            src="/innovation_logo.png"
            alt="PriceSpider Innovation"
            style={{
              position: 'fixed', bottom: 0, right: 0, width: 48, background: 'white', padding: '2px', zIndex: 100000,
            }}
          />
        </main>
      </Router>
    );
  }
}
